import { memo } from "react";

import {
    BTButtonDeprecated,
    type IBTButtonDeprecatedProps,
} from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTIconPlusCircleFilled } from "commonComponents/btWrappers/BTIcon";

type IgnoredProps = Pick<
    IBTButtonDeprecatedProps<string>,
    "type" | "icon" | "underline" | "isolated"
>;
type PartialProps = Partial<Pick<IBTButtonDeprecatedProps<string>, "isolated">>;

/**
 * Button for adding emails used within the InputEmailList component
 */
export const InputEmailCreateNew = memo(function <ActionType>(
    props: Omit<IBTButtonDeprecatedProps<ActionType>, keyof IgnoredProps> & PartialProps,
) {
    return (
        <BTButtonDeprecated<ActionType> {...props} type="link" icon={<BTIconPlusCircleFilled />} />
    );
});
